import styled from 'styled-components';

export const ToggleDiv = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    left: 12px;
    justify-content: flex-start;
    margin-bottom: 15px;
`;

export const ToggleSpan = styled.span`
    z-index: 3;
    color: white;
`;
